import React from 'react';

const Badge = ({ children, color = 'blue' }) => {
  const styles = {
    blue: "bg-blue-50 text-blue-600",
    green: "bg-green-50 text-green-600",
    gray: "bg-gray-100 text-gray-500",
    red: "bg-red-50 text-red-600",
    orange: "bg-orange-50 text-orange-600",
  };
  return (
    <span className={`px-2 py-0.5 rounded-md text-xs font-medium ${styles[color] || styles.blue}`}>
      {children}
    </span>
  );
};

export default Badge;
